import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import * as _ from "lodash";
import { formatComma } from "../../utils/stringFormat";
import { PATH } from "../../routes/Routes";
import { DELETE } from "../../utils/HttpClient";
import { Toast } from "../../utils/Toast";
import MainHeader from "../../components/common/MainHeader";
import ReportExportButton from "../../components/common/ReportExportButton";
import { URL_POST_BAKING, URL_REPORT } from "../../constance/urls";
import ConfirmModal from "../../components/common/ConfirmModal";
import TSTable from "../../components/common/TSTable";
import { Layout, List, Space, Button, Form, Row, Col, Tooltip, Input, DatePicker, Select } from "antd";
import moment from "moment";
import { Content } from "antd/es/layout/layout";
import Title from "antd/es/typography/Title";
import dayjs from "dayjs";
import { HUMAN_DATE_FORMAT, DATE_FORMAT } from "../../constance/strings";
import { FileTextFilled, DeleteFilled } from "@ant-design/icons";
import { useDebounce } from "use-debounce";
import { BLUE_COLOR } from "../../constance/color";
import ColorButton from "../../components/common/ColorButton";
import { toHumanDate, toHumanDateTime } from "../../utils/Utils";


export default function PostBakingWasteWoodInputListView() {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const history = useHistory();
  const tableRef = React.useRef();
  const [loading, setLoading] = React.useState(false);
  const dateTypeFiter = Form.useWatch('date', form);
  const dateRange = Form.useWatch('dateRange', form);
  const ovenFilter = Form.useWatch('oven_no', form);
  const [deleteConfirm, setDeleteConfirm] = React.useState(null);
  const { RangePicker } = DatePicker;
  const haveDateRange = _.get(dateRange, 0, null) && _.get(dateRange, 1, null)
  const [debouncedText] = useDebounce(ovenFilter, 500);

  React.useEffect(() => {
    if (tableRef.current) {
      tableRef.current.fetch();
    }
  }, [dateRange, debouncedText])

  const columns = React.useMemo(() => [
    {
      title: t('barcodes.barcode_id'),
      dataIndex: 'barcode',
    },
    {
      title: t('post_baking_waste_wood_count.group_date'),
      dataIndex: 'post_baking_group_date',
      render: (__, original) => original.post_baking_group_date ?  toHumanDate(original.post_baking_group_date) : '',
    },
    {
      title: t('post_baking_waste_wood_input.input_date'),
      dataIndex: 'input_date',
      render: (__, original) => original.post_baking_group_date ? toHumanDate(original.input_date) : '',
    },
    {
      title: t('wood_size'),
      render: (__, original) => {
        const value = _.get(original, 'wood_size_amount_map_list', [])
        return value ? (
          <List>
            {value.filter(data => _.get(data, 'amount', 0)).map(data => (
              <List.Item>{_.get(data, 'wood_code', '')} - {`(${formatComma(_.get(data, 'amount', 0))})`} {formatComma(_.get(data, 'volume', 0), 4)}</List.Item>
            ))}
          </List>
        ) : '-'
      }
    },
    {
      title: t('workflows.action'),
      dataIndex: 'id',
      render: (__, original) => (
        <div style={{ textAlign: 'center' }}>
          <Space>
            <ColorButton
              variant="outlined"
              color='primary'
              override={BLUE_COLOR}
              icon={<FileTextFilled />}
              loading={loading}
              onClick={() => history.push(`${PATH.POST_BAKING_WASTE_WOOD_INPUT_REPORT}${original.id}`)} >
              {!_.get(original, 'interfaced', false) ? t('edit') : t('detail')}
            </ColorButton>
            {!_.get(original, 'interfaced', false) &&
              <Button
                variant="outlined"
                color="danger"
                icon={<DeleteFilled />}
                loading={loading}
                onClick={() => setDeleteConfirm(original.id)} >{t('delete')}</Button>
            }
          </Space>
        </div>
      ),
    },

  ])

  const handleDelete = async () => {
    setLoading(true);
    try {
      await DELETE(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT_TRANSACTION}${deleteConfirm}/`)
      if (tableRef.current) {
        tableRef.current.fetch();
      }
      Toast.success(`${t('delete')} ${t('success')}`)
    } catch (error) {
      Toast.error(error.errorMessages);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <Layout>
        <MainHeader />
        <Content style={{ margin: '24px', marginTop: '7em' }}>
          <Title level={2}>{t('menus.report_menus.waste_woods.post_baking_waste_wood_input')}</Title>
          <Form form={form}>
            <Row gutter={16}>
              <Col sm={24} md={24} lg={4}>
                <Form.Item label={t('date_type')} name={"date"} initialValue={"date"}>
                  <Select
                    options={[
                      { key: 'date', value: 'date', label: t('post_baking_waste_wood_count.group_date') },
                      { key: 'input_date_range', value: 'input_date_range', label: t('post_baking_waste_wood_input.input_date') },
                    ]}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col sm={24} md={24} lg={8}>
                <Form.Item label={t('date')} name={"dateRange"}>
                  <RangePicker
                    format={HUMAN_DATE_FORMAT}
                    placeholder={[
                      t('searchs.placeholders.startDate'),
                      t('searchs.placeholders.endDate'),
                    ]}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col sm={24} md={24} lg={8} >
                <Form.Item label={t('post_baking_waste_wood_count.oven_no')} name={"oven_no"}>
                  <Input placeholder={t('all')} allowClear type="number" />
                </Form.Item>
              </Col>
              <Col sm={24} md={24} lg={4} style={{ textAlign: 'right', marginBottom: '1rem' }}>
                <Tooltip title={!haveDateRange ? t('searchs.placeholders.date') : ""}>
                  <span >
                    <ReportExportButton
                      url={`${URL_REPORT.POST_BAKING_WASTE_WOOD_INPUT_REPORT}excel/`}
                      title={t('menus.report_menus.waste_woods.post_baking_waste_wood_input')}
                      type='excel'
                      disabled={!haveDateRange}
                      params={{
                        oven: ovenFilter,
                        [`${dateTypeFiter}_after`]: _.get(dateRange, 0, null) ? dateRange[0].format('YYYY-MM-DD') : null,
                        [`${dateTypeFiter}_before`]: _.get(dateRange, 1, null) ? dateRange[1].format('YYYY-MM-DD') : null,
                      }}/>
                  </span>
                </Tooltip>
              </Col>
            </Row>
          </Form>

          <TSTable
            ref={tableRef}
            columns={columns}
            url={URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT_TRANSACTION}
            params={{
              oven: ovenFilter,
              [`${dateTypeFiter}_after`]: _.get(dateRange, 0, null) ? dateRange[0].format('YYYY-MM-DD') : null,
              [`${dateTypeFiter}_before`]: _.get(dateRange, 1, null) ? dateRange[1].format('YYYY-MM-DD') : null,
            }}/>
        </Content>
      </Layout>
      <ConfirmModal
        open={deleteConfirm != null}
        onClose={() => setDeleteConfirm(null)}
        title={`${t('confirms.delete_title')}`}
        content={`${t('confirms.delete_content')}`}
        onConfirm={handleDelete} />

    </div>
  )
}

